module.exports = __webpack_public_path__ + "assets/img/user1.f4e5e8db.png";